export default {
    activation: 'Activation',
    arrival: 'Arrival',
    creation: 'Creation',
    delivery: 'Delivery',
    departure: 'Departure',
    load: 'Load',
    offload: 'Offload',
    reflight: 'Reflight',
    uldPositioning: 'UldPositioning',
    unload: 'Unload',
    flightCancelled: 'FlightCancelled',
};
